<script setup>
defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: value =>
      ['default', 'standard', 'form', 'panel'].includes(value),
  },
  layout: {
    type: String,
    default: 'col',
  },
  selectable: {
    type: Boolean,
    default: false,
  },
  hoverable: {
    type: Boolean,
    default: false,
  },
  fill: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click');
};
</script>

<template>
  <div
    class="group/cardLayout flex w-full flex-col border border-n-card-border bg-n-solid-2 transition-shadow duration-200 dark:bg-[#101113]"
    :class="[
      {
        'rounded p-2': variant === 'default',
        'rounded-lg p-4': variant === 'standard',
        'rounded-xl p-4': variant === 'form',
        'overflow-hidden rounded-lg p-0': variant === 'panel',
        'cursor-pointer': selectable,
        'hover:shadow-[0_0_14px_rgba(15,23,42,0.12)]': hoverable,
      },
    ]"
  >
    <div
      class="flex w-full gap-3"
      :class="[
        layout === 'col' ? 'flex-col' : 'flex-row justify-between items-center',
        { '!gap-0': variant === 'panel', 'flex-1': fill },
      ]"
      @click="handleClick"
    >
      <slot />
    </div>

    <slot name="after" />
  </div>
</template>
